
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Acbusonrentinpune() {



    const cardData =
    {
        keyword: 'AC Bus On Rent in Pune',
        heading: 'Amruta Travels: AC Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers AC Bus on Rent in Pune, providing a comfortable and reliable transportation solution for various occasions. Whether you are planning a corporate event, wedding, school trip, or a family outing, our fleet of air-conditioned buses ensures a pleasant and hassle-free journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our range of AC buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your AC Bus with Amruta Travels and travel together in comfort and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

    "services": [
    {
      "name": "AC Bus for Hire in Pune",
      "description": "Amruta Travels offers a fleet of well-maintained AC buses for hire in Pune, perfect for all types of travel—be it weddings, corporate events, family tours, or religious trips. Enjoy a cool, comfortable, and safe journey with our air-conditioned buses operated by professional drivers."
    },
    {
      "name": "AC Bus for Mumbai Darshan from Pune",
      "description": "Explore the iconic sights of Mumbai with Amruta Travels’ AC bus service for Mumbai Darshan from Pune. Our comfortable air-conditioned buses ensure a relaxed sightseeing experience, ideal for large groups, families, or corporate outings heading to Mumbai for a day or overnight tour."
    },
    {
      "name": "Pune to Mumbai Airport Tempo Traveller on Rent",
      "description": "Amruta Travels offers convenient Tempo Traveller rentals from Pune to Mumbai Airport. With AC comfort and ample luggage space, this is the perfect solution for airport drop-offs and pickups for families, corporate groups, or wedding guests traveling together."
    },
    {
      "name": "Pune to Jejuri Tempo Traveller Rent",
      "description": "Book a Tempo Traveller from Pune to Jejuri with Amruta Travels for a spiritual and comfortable trip. Our vehicles are ideal for small groups visiting the Khandoba Temple, ensuring a smooth ride with AC comfort, flexible timing, and experienced drivers."
    },
    {
      "name": "Bharat Benz AC Seater Bus on Rent",
      "description": "Amruta Travels offers Bharat Benz AC seater buses on rent in Pune for luxurious and comfortable travel. These buses are ideal for long-distance tours, weddings, and corporate travel, offering premium interiors, powerful performance, and smooth rides across all routes."
    },
    {
      "name": "17, 26, 32, 35, 45 AC Seater Bharat Benz Bus On Hire",
      "description": "Choose from a range of Bharat Benz AC buses in 17, 26, 32, 35, and 45-seater configurations for group travel in and out of Pune. Amruta Travels ensures luxury, space, and convenience with each ride, perfect for weddings, corporate outings, and pilgrimage tours."
    },
    {
      "name": "Pune to Goa AC Bus Hire On Rent",
      "description": "Plan your Goa getaway with Amruta Travels’ AC bus rentals from Pune. Our long-distance buses are designed for comfort, featuring reclining seats, air conditioning, and entertainment options for a pleasant road trip to Goa. Ideal for group vacations and college trips."
    },
    {
      "name": "Hire Pune to Kolhapur Car, Bus & Tempo Traveller on Rent",
      "description": "Amruta Travels provides a range of vehicle rentals from Pune to Kolhapur including AC buses, Tempo Travellers, and cars. Whether you’re visiting the Mahalakshmi Temple or attending a family function, our fleet ensures a smooth and comfortable journey tailored to your group size and preference."
    },
    {
      "name": "AC Bus on Rent in Pimpri Chinchwad",
      "description": "Residents and businesses in Pimpri Chinchwad can rely on Amruta Travels for AC bus rentals for all travel needs. Our buses are clean, spacious, and fully air-conditioned, ideal for corporate events, school trips, or outstation tours from PCMC areas."
    },
    {
      "name": "AC Bus for School Picnic in Pune",
      "description": "Organize a safe and enjoyable school picnic with Amruta Travels' AC buses in Pune. Designed for student safety and comfort, our buses are spacious, temperature-controlled, and driven by well-trained professionals experienced in handling school group logistics."
    },
    {
      "name": "Urbania Bus on Rent in Pune",
      "description": "Amruta Travels offers the latest Force Urbania buses on rent in Pune. These luxury mini buses are perfect for city tours, outstation trips, and premium group travel with high-end interiors, air conditioning, and smooth suspension for added comfort on long routes."
    },
    {
      "name": "Force Urbania Luxury Mini Bus On Rent",
      "description": "Experience travel in style with our Force Urbania luxury mini buses. Ideal for high-end group travel, corporate trips, and VIP movement, these vehicles feature plush seating, superior AC, and ample space. Available for hire in Pune and surrounding areas."
    },
    {
      "name": "AC 17 Seater Bus on Rent in Pune",
      "description": "Need a mid-sized AC bus for your trip? Amruta Travels offers 17-seater air-conditioned buses that are perfect for small group travel, corporate trips, or religious tours. These buses provide a comfortable ride with spacious seating and reliable service."
    }
  ],
  "tableData": [
    ["AC Bus for Hire in Pune", "AC Bus for Mumbai Darshan from Pune"],
    ["Pune to Mumbai Airport Tempo Traveller on Rent", "Pune to Jejuri Tempo Traveller Rent"],
    ["Bharat Benz AC Seater Bus on Rent", "17, 26, 32, 35, 45 AC Seater Bharat Benz Bus On Hire"],
    ["Pune to Goa AC Bus Hire On Rent", "Hire Pune to Kolhapur Car, Bus & Tempo Traveller on Rent"],
    ["AC Bus on Rent in Pimpri Chinchwad", "AC Bus for School Picnic in Pune"],
    ["Urbania Bus on Rent in Pune", "Force Urbania Luxury Mini Bus On Rent"],
    ["AC 17 Seater Bus on Rent in Pune", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Cool and Comfortable Travel Experience",
    "WhyChoosedescription": "Amruta Travels offers AC Bus on Rent in Pune, perfect for beating the heat while traveling. Our air-conditioned buses ensure a relaxed, cool, and comfortable ride for every passenger."
  },
  {
    "WhyChooseheading": "Ideal for All Occasions",
    "WhyChoosedescription": "Whether it’s a corporate event, wedding, school trip, or city tour, our AC buses are perfect for every group travel need—offering convenience and comfort on every occasion."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All our AC buses are operated by experienced, well-trained drivers who are punctual, polite, and committed to providing a safe and smooth journey across Pune and beyond."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We provide AC Bus on Rent in Pune at competitive rates with no hidden charges. Our upfront pricing helps you plan your group travel without any budget surprises."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "All buses undergo regular maintenance and cleaning to ensure a hygienic and hassle-free experience. Our fleet is kept in excellent condition for your peace of mind."
  },
  {
    "WhyChooseheading": "Flexible Timing and Routes",
    "WhyChoosedescription": "Our AC bus rental service is available with flexible pick-up and drop-off times and customizable routes. We adapt to your schedule, not the other way around."
  },
  {
    "WhyChooseheading": "Fleet Options for All Group Sizes",
    "WhyChoosedescription": "From 20-seaters to 50-seaters, our air-conditioned buses come in various capacities to suit your group size and travel needs—comfortably and efficiently."
  },
  {
    "WhyChooseheading": "Quick Booking and Reliable Support",
    "WhyChoosedescription": "Booking an AC Bus on Rent in Pune with Amruta Travels is fast and easy. Our friendly support team is available to assist you at every step of your travel planning."
  }
]




























    }

const faqData = [
  {
    question: 'How can I rent an AC bus in Pune with Amruta Travels?',
    answer: 'Renting an AC bus in Pune with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll assist you in choosing the right AC bus based on your group size and travel requirements.',
  },
  {
    question: 'What types of AC buses are available for rent in Pune?',
    answer: 'We offer a range of AC buses, including 32, 35, 45, and 50 seater models. All our AC buses are spacious, comfortable, and equipped with modern amenities for a relaxed journey.',
  },
  {
    question: 'Are AC buses suitable for both local and outstation travel?',
    answer: 'Yes, our AC buses are ideal for both local city travel and outstation trips. Whether it’s a short city ride or a multi-day journey, we ensure a cool and comfortable experience for all passengers.',
  },
  {
    question: 'Are the AC buses well-maintained and clean?',
    answer: 'Absolutely! All our AC buses are regularly serviced, thoroughly cleaned, and sanitized before every trip. We prioritize passenger safety, hygiene, and comfort.',
  },
  {
    question: 'How much does it cost to rent an AC bus in Pune?',
    answer: 'The cost of renting an AC bus in Pune depends on the seating capacity, distance, and duration of travel. Contact us with your travel details for a personalized and transparent quote.',
  },
  {
    question: 'Can I hire an AC bus for weddings, corporate events, or school trips?',
    answer: 'Yes, our AC buses are perfect for all kinds of occasions including weddings, corporate events, school outings, religious trips, and more. We provide tailored services based on your event needs.',
  },
  {
    question: 'Do you provide drivers with the AC bus rental?',
    answer: 'Yes, all AC bus rentals include experienced and licensed drivers who ensure safe, punctual, and smooth travel for your group.',
  },
  {
    question: 'Can I customize the pickup and drop-off locations?',
    answer: 'Yes, we offer flexible routes with multiple pickup and drop-off points. Just share your itinerary with us, and we’ll take care of the rest.',
  },
  {
    question: 'Why choose Amruta Travels for AC bus rental in Pune?',
    answer: 'Amruta Travels offers reliable service with well-maintained AC buses, professional drivers, and a commitment to customer satisfaction. We ensure a hassle-free and enjoyable travel experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Anil Bhate',
    role: 'Corporate Team Lead, Pune',
    text: 'We booked a 45-seater AC bus from Amruta Travels for our team outing. The bus was very clean, the air conditioning was great, and the driver was professional. A very comfortable journey!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kale',
    role: 'Wedding Organizer, Pune',
    text: 'Amruta Travels provided a 50-seater AC bus for our wedding guests. The bus arrived on time and was in excellent condition. The guests had a very pleasant experience. Highly recommended!',
    rating: 5,
  },
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/ac-bus-on-rent-pune.jpg",
  "description": "Rent an AC bus in Pune for Mumbai Darshan, Goa trips, school picnics, and other outstation travels. Choose from 17, 26, 32, 35, and 45-seater Bharat Benz luxury buses and more for comfortable travel with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4782"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "80", // Adjust based on per km or flat rate for AC bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-bus-on-rent-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | AC Bus On Rent in Pune | Comfortable Bus Hire for Outstation & School Trips | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent an AC bus in Pune for Mumbai Darshan, Goa, and school picnics. Choose from 17, 26, 32, 35, and 45-seater luxury Bharat Benz buses with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Acbusonrentinpune;